import { render } from "./RenameModal.vue?vue&type=template&id=f4e0e912"
import script from "./RenameModal.vue?vue&type=script&lang=js"
export * from "./RenameModal.vue?vue&type=script&lang=js"
script.render = render

export default script